import React, { useContext } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import { Login } from "../screens/Login";
import Login from "../screens/Login/Login";
import TalentSignupForm from "../screens/SignUp/TalentSignupForm";
import { AuthContext } from "../providers/AuthProvider";
// import { ClientProfile } from "../screens/ClientProfile";
import ClientProfile from "../screens/ClientProfile/ClientProfile";
import CheckProfile from "../screens/ClientProfile/CheckProfile";
import { AuthorizedLayout } from "../components/AuthorizedLayout";
import { Skills } from "../screens/Skills";
import { UpdateSkills } from "../screens/UpdateSkills";
import { Home } from "../screens/Home";
import { Knowledge } from "../screens/Knowledge";
import SelfieLetter from "../screens/SelfieLetter";
import CulturalFIt from "../screens/CulturalFIt";
import { FAQ } from "../screens/FAQ";
import { Inbox } from "..//screens/Inbox";
import Chat from "../screens/Inbox/Chat";
import { Academy } from "../screens/Academy";
import { DetailsCurso } from "../screens/Academy/components/cursos/DetailsCurso";
import { DetailsPodLive } from "../screens/Academy/components/DetailsPodLive/DetailsPodLive";
import { PlayVideo } from "../screens/Academy/components/cursos/PlayVideo";

//routes companies
import LoginCompanies from "../ScreensCompanies/Login/Login";
import SignUpCompanies from "../ScreensCompanies/SignUp/Index";
import Painels from "../ScreensCompanies/Painels/Painels";
import Complete from "../ScreensCompanies/SignUp/components/Complete";
import TalentSearch from "../ScreensCompanies/TalentSearch";
import DetailsTalent from "../ScreensCompanies/TalentSearch/DetailsTalent";
import Profile from "../ScreensCompanies/Profile/Profile";
import CompanyChangePlan from "../ScreensCompanies/Profile/CompanyChangePlan";
import { UserTypeSelector } from "../screens/UserTypeSelector/UserTypeSelector";
import EmbeddedTalentForm from "../screens/EmbeddedTalentForm/EmbeddedTalentForm";
import EmbeddedTalentFormLive from "../screens/EmbeddedTalentFormLive/EmbeddedTalentFormLive";
import EmbeddedCompanyForm from "../screens/EmbeddedCompanyForm/EmbeddedCompanyForm";
import PublicTalentProfile from "../screens/PublicTalentProfile";
import CompanyRegistrationForm from "../screens/CompanyRegistrationForm/CompanyRegistrationForm";

import RequiredPhotoUpload from "../screens/RequiredPhotoUpload/RequiredPhotoUpload";

const Routers = () => {
  const { signOut } = useContext(AuthContext);

  if (
    window.location.protocol === "http:" &&
    window.location.hostname !== "localhost"
  ) {
    window.location.href = window.location.href.replace("http:", "https:");
    return null;
  }

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        {/* REQUIRED PHOTO UPLOAD */}
        <Route
          path="/upload-photo"
          element={
            <PrivateRoute requirePhoto={false}>
              <RequiredPhotoUpload />
            </PrivateRoute>
          }
        />

        {/* CLIENT ROUTES */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/skills"
          element={
            <PrivateRoute>
              <Skills />
            </PrivateRoute>
          }
        />

        <Route
          path="/skills/:id"
          element={
            <PrivateRoute>
              <UpdateSkills />
            </PrivateRoute>
          }
        />

        <Route
          path="/knowledge"
          element={
            <PrivateRoute>
              <Knowledge />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <ClientProfile />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/status"
          element={
            <PrivateRoute>
              <CheckProfile />
            </PrivateRoute>
          }
        />

        <Route
          path="/selfie-letter"
          element={
            <PrivateRoute>
              <SelfieLetter />
            </PrivateRoute>
          }
        />

        <Route
          path="/fit-cultural"
          element={
            <PrivateRoute>
              <CulturalFIt />
            </PrivateRoute>
          }
        />

        <Route
          path="/faq"
          element={
            <PrivateRoute>
              <FAQ />
            </PrivateRoute>
          }
        />

        <Route
          path="/inbox"
          element={
            <PrivateRoute>
              <Inbox />
            </PrivateRoute>
          }
        />

        <Route
          path="/chat/:id"
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />

        <Route
          path="/academy"
          element={
            <PrivateRoute>
              <Academy />
            </PrivateRoute>
          }
        />

        <Route
          path="/course/:aulaNome/:id"
          element={
            <PrivateRoute>
              <DetailsCurso />
            </PrivateRoute>
          }
        />

        <Route
          path="/course/:cursoId/lesson/:aulaId"
          element={
            <PrivateRoute>
              <PlayVideo />
            </PrivateRoute>
          }
        />

        <Route
          path="/:type/:aulaNome/:id"
          element={
            <PrivateRoute>
              <DetailsPodLive />
            </PrivateRoute>
          }
        />

        {/* PUBLIC ROUTES */}
        <Route
          exact
          path="/"
          element={
            <PublicRoute>
              <UserTypeSelector />
            </PublicRoute>
          }
        />

        <Route
          exact
          path="/talents"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          exact
          path="/talents/signup"
          element={
            <PublicRoute>
              <TalentSignupForm />
            </PublicRoute>
          }
        />

        <Route
          exact
          path="/talents/form-embed"
          element={<EmbeddedTalentForm />}
        />

        <Route
          exact
          path="/talents/form-embed-live"
          element={<EmbeddedTalentFormLive />}
        />

        <Route
          exact
          path="/companies/form-embed"
          element={<EmbeddedCompanyForm />}
        />

        {/* Public Talent Profile Route */}
        <Route
          exact
          path="/talents/profile/:slug"
          element={<PublicTalentProfile />}
        />

        <Route
          exact
          path="/companies"
          element={
            <PublicRoute>
              <LoginCompanies />
            </PublicRoute>
          }
        />

        {/* <Route
          exact
          path="/companies/signup"
          element={
            <PublicRoute>
              <SignUpCompanies />
            </PublicRoute>
          }
        /> */}

        <Route
          exact
          path="/companies/signup"
          element={
            <CompanyRegistrationForm />}
        />

        <Route
          exact
          path="/companies/signup/complete"
          element={
            <PublicRoute>
              <Complete />
            </PublicRoute>
          }
        />

        <Route
          exact
          path="/companies/panel"
          element={
            <PrivateRoute>
              <Painels />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path="/companies/talents"
          element={
            <PrivateRoute>
              <TalentSearch />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path="/companies/talents/profile/:id"
          element={
            <PrivateRoute>
              <DetailsTalent />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path="/companies/settings"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          exact
          path="/companies/settings/change-plan"
          element={
            <PrivateRoute>
              <CompanyChangePlan />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<h1>404 Not found</h1>} />
      </Routes>
    </BrowserRouter>
  );
};

function PublicRoute({ children }) {
  const { user } = useContext(AuthContext);
  if (user) {
    if (user?.type === "talent") return <Navigate to="/home" />;
    return <Navigate to="/companies/panel" />;
  } else {
    return children;
  }
}

function PrivateRoute({ children, requirePhoto = true }) {
  const { user } = useContext(AuthContext);
  const location = window.location.pathname;

  if (!user) {
    return <Navigate to="/" />;
  }

  // Check if talent needs to upload photo
  if (
    requirePhoto &&
    user?.type === "talent" &&
    !user?.avatar &&
    location !== "/upload-photo"
  ) {
    return <Navigate to="/upload-photo" replace />;
  }

  return children;
}

export default Routers;
